import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '../routes'
import store from './store'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    base: __dirname,
    transitionOnLoad: true,
    linkActiveClass: 'active',
    routes
})

const debug_url = '/debugmode'

router.beforeEach((route, redirect, next) => {
    if (route.path === '/vraag') {
        if (store.state.game.episodes[store.state.game.episode].points && (store.state.game.episodes[store.state.game.episode].answers.length === store.state.game.episodes[store.state.game.episode].actions.length)) {
            return router.push('/overzicht')
        }
    }
    if (route.path === debug_url) {
        store.dispatch('ENABLE_DEBUGMODE').then(() => {
            router.push('/tijdlijn')
        })
    } else {
        const firstEpisodeOnly = ['/introimage', '/infoscreen']
        if (store.state.game.episode > 0 && firstEpisodeOnly.indexOf(route.path) != -1) {
            return router.push('/vraag')
        }
        next()
    }
})

router.afterEach((route, redirect) => {
    if (window.mobile && route.path !== '/') {
        setTimeout(function () {
            window.scrollTo(0, route.meta.scrollTop)
        }, 500)
    }
})

export default router



// WEBPACK FOOTER //
// ./src/services/router.js